'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Payments = {

    async getActivePlans() {
        try {
            let plans = {
                1: [], 
                3: [], 
                12: []
            };

            let planDetails = await this.getAllPlanDetails();

            let response = await axios.get(API_URL + '/getStripePlans');

            for (let plan of response.data) {
                if (plan.plan_data.active === true) {
                    if (plan.duration === 1) {
                        for (let detail of planDetails) {
                            if (detail.plan_type == plan.type) {
                                plan.id = detail.id;
                            }
                        }
                        plans['1'].push(plan);
                    } else if (plan.duration === 3) {
                        for (let detail of planDetails) {
                            if (detail.plan_type == plan.type) {
                                plan.id = detail.id;
                            }
                        }
                        plans['3'].push(plan);
                    } else if (plan.duration === 12) {
                        for (let detail of planDetails) {
                            if (detail.plan_type == plan.type) {
                                plan.id = detail.id;
                            }
                        }
                        plans['12'].push(plan);
                    }
                }
            }
            
            return plans;

        } catch (error) {
            return false;
        }
    },

    async getAllPlanDetails() {
        let response = await axios.get(API_URL + '/plans');

        return response.data;
    },

    async getPlanPrice(planID) {
        if (!planID) {
            return { error: "Plan ID is required" };
        }

        let plan = null;

        let response = await axios.get(API_URL + '/getStripePlans');

        response.data.forEach(item => {
            if (item.plan_id == planID) {
                plan = item;
            }
        });

        if (plan != null) {
            return plan.plan_data.amount / 100;
        }

        return false;
    }
    
}

export default Payments;